<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <!-- パンくずリスト -->
        <BreadCrumbs v-model="currentGroupId" @click_breadCrumbs="selectedGroupChange" />
        <v-divider />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <!-- 進捗バー -->
        <v-progress-linear
          v-model="progression.value"
          :active="progression.active"
          color="primary"
          buffer-value="0"
          stream
        ></v-progress-linear>
        <v-card outlined tile class="d-flex justify-center">
          <!-- 右サイドメニュー -->
          <v-navigation-drawer
            v-if="targetMarker"
            :value="drawer"
            app
            mobile-breakpoint="0"
            right
            disable-resize-watcher
            disable-route-watcher
            width="320"
            class="v-nav"
          >
            <div class="right-nav-header">
              <!-- サイドバーのヘッダー -->
              <v-toolbar color="primary" dark dense flat>
                <v-btn @click="closeDrawer" icon>
                  <v-icon>mdi-menu-close</v-icon>
                </v-btn>
                <!-- 需要家リンク -->
                <v-toolbar-title class="text-body-2">
                  {{ targetMarker.title }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-menu v-model="consumerMenu" offset-y close-on-content-click tile min-width="280">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on">{{ consumerMenu ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                  </template>
                  <v-list dense class="py-0">
                    <v-list-item-group color="primary">
                      <v-list-item
                        @click="openHomeConsumerPage(deviceGroup.device_group_id)"
                        v-for="deviceGroup in targetMarker.deviceGroups"
                        :key="deviceGroup.device_group_id"
                      >
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ deviceGroup.parent.device_group_name_locale1 }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-menu>
              </v-toolbar>
              <!-- センサーデータのサマリー -->
              <v-toolbar dense flat class="sensor-summary">
                <v-row dense>
                  <v-col cols="3" class="text-h6"
                    ><v-sheet color="#EF5350" dark class="d-flex">
                      <div class="text-center sensor-data-title">E</div>
                      <div class="text-center sensor-data-number">{{ targetMarker.emergency }}</div>
                    </v-sheet>
                  </v-col>
                  <v-col cols="3" class="text-h6"
                    ><v-sheet color="#FF9800" dark class="d-flex">
                      <div class="text-center sensor-data-title">C</div>
                      <div class="text-center sensor-data-number">{{ targetMarker.caution }}</div>
                    </v-sheet>
                  </v-col>
                  <v-col cols="3" class="text-h6"
                    ><v-sheet color="#FDD835" dark class="d-flex">
                      <div class="text-center sensor-data-title">M</div>
                      <div class="text-center sensor-data-number">{{ targetMarker.maintenance }}</div>
                    </v-sheet>
                  </v-col>
                  <v-col cols="3" class="text-h6"
                    ><v-sheet color="#9E9E9E" dark class="d-flex">
                      <div class="text-center sensor-data-title"><v-icon>mdi-signal-off</v-icon></div>
                      <div class="text-center sensor-data-number">{{ targetMarker.disConnection }}</div>
                    </v-sheet>
                  </v-col>
                </v-row>
              </v-toolbar>
            </div>
            <!--deviceの情報 -->
            <v-row class="ma-1" dense>
              <v-col v-for="device in targetMarker.devices" :key="device.serial_no" cols="12">
                <v-card
                  :to="{
                    name: 'CompressorInfo',
                    params: {
                      model_id: device.model_id,
                      serial_no: device.serial_no,
                    },
                    query: {
                      locale: $i18n.locale,
                    },
                  }"
                  target="_blank"
                  outlined
                  height="300"
                  :style="{
                    border: `10px solid ${cardColor(device)}`,
                  }"
                >
                  <v-card-text class="card-text">
                    <v-row justify="end">
                      <v-col v-if="device.communication" cols="5">
                        <v-row dense>
                          <!-- 接続状態 -->
                          <v-col cols="4" class="connection-area">
                            <v-icon large v-text="device.disConnection ? 'mdi-signal-off' : 'mdi-signal'"> </v-icon>
                          </v-col>
                          <!-- メンテナンス通知 -->
                          <v-col cols="8" class="maintenance-notification-area">
                            <v-icon
                              v-if="['danger', 'warning', 'notice'].includes(device.maintenanceNotificationStatus)"
                              large
                              :color="maintenanceNotificationIcon(device.maintenanceNotificationStatus).color"
                              class="material-symbols-outlined"
                            >
                              {{ maintenanceNotificationIcon(device.maintenanceNotificationStatus).name }}
                            </v-icon>
                          </v-col>
                          <v-spacer></v-spacer>
                          <!-- アラーム表示領域 -->
                          <v-col cols="12" class="text-center alarm-area">
                            <v-row v-if="blinkStart" dense align="center" justify="center">
                              <v-col v-if="device.emergency" cols="4">
                                <v-img src="@/assets/emergency.png" height="48" contain class="blinking"> </v-img>
                              </v-col>
                              <v-col v-if="device.caution" cols="4">
                                <v-img src="@/assets/caution.png" height="48" contain class="blinking"> </v-img>
                              </v-col>
                              <v-col v-if="device.maintenance" cols="4">
                                <v-img src="@/assets/maintenance.png" height="48" contain class="blinking"> </v-img>
                              </v-col>
                            </v-row>
                          </v-col>
                          <!-- 接続状態 -->
                          <v-col cols="12" class="cog-area text-center">
                            <v-img
                              v-if="device.start && !device.disConnection"
                              src="@/assets/cog_run.gif"
                              height="40"
                              contain
                            >
                            </v-img>
                            <v-img v-else src="@/assets/cog_stop.jpg" height="40" contain> </v-img>
                          </v-col>
                        </v-row>
                      </v-col>
                      <!-- コンプレッサー表示領域 -->
                      <v-col cols="7" align-self="center">
                        <v-img
                          v-if="deviceType(device.model_id) === 'OIL_INJECTION'"
                          src="@/assets/oil_injection.png"
                          height="120"
                          width="100%"
                          contain
                          :style="{
                            opacity: device.communication ? 1 : 0.5,
                          }"
                        >
                        </v-img>
                        <v-img
                          v-else
                          src="@/assets/oil_free.png"
                          height="120"
                          width="100%"
                          contain
                          :style="{
                            opacity: device.communication ? 1 : 0.5,
                          }"
                        >
                        </v-img>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-row class="compressor-info text-center font-weight-bold" dense>
                      <v-col cols="12">{{ device.optional_info_2 }}</v-col>
                      <v-col cols="12">{{ device.serial_no.replace(/_.*$/, '') }}</v-col>
                      <v-col cols="12">{{ device.optional_info_1 }}</v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-navigation-drawer>
          <!-- 検索フォーム -->
          <v-row no-gutter class="control-area">
            <v-col cols="6" class="d-flex align-center justify-start">
              <v-text-field
                @keydown.enter.prevent="searchMarker('enter')"
                @compositionstart="isComposing = true"
                @compositionend="isComposing = false"
                v-model="inputText"
                color="primary"
                :placeholder="$t('searchConsumerName')"
                clearable
                solo
                dense
                hide-details
                flat
                class="serach-marker-input gmap-control-shadow"
              ></v-text-field>
              <v-btn @click="searchMarker" color="primary" class="ml-2 gmap-control-shadow" dark
                ><v-icon>mdi-magnify</v-icon></v-btn
              >
              <v-btn v-show="searchText" @click="searchClear" color="primary" class="ml-2 gmap-control-shadow" dark
                ><v-icon>mdi-magnify-close</v-icon></v-btn
              >
            </v-col>
            <!-- ボタンコントロール -->
            <v-col cols="6" class="align-center justify-end d-flex">
              <v-btn
                v-if="toggleList.length"
                @click="setFilterStatus('all')"
                color="primary"
                class="gmap-control-shadow"
                ><v-icon size="20">mdi-filter-off</v-icon></v-btn
              >
              <v-btn-toggle
                @change="setFilterStatus"
                v-model="toggleList"
                multiple
                dense
                class="gmap-control-shadow btn-toggle ml-2"
              >
                <v-btn> E </v-btn>
                <v-btn> C </v-btn>
                <v-btn> M </v-btn>
                <v-btn>
                  <v-icon size="20" :color="toggleList.includes(3) ? 'white' : ''">mdi-signal-off</v-icon>
                </v-btn>
              </v-btn-toggle>
            </v-col>
          </v-row>
          <!-- 地図領域 -->
          <GoogleMap @set-target-marker="setTargetMarker" ref="googleMap" />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import BreadCrumbs from '@/components/BreadCrumbs.vue';
  import GoogleMap from '@/components/GoogleMap.vue';
  import modelMapping from '@/resources/model_mapping.json';
  import { mapGetters } from 'vuex';
  import '@/assets/css/consumer.css';

  export default {
    title() {
      return this.$t(this.$route.meta.title);
    },
    name: 'ConsumerMap',
    components: {
      BreadCrumbs,
      GoogleMap,
    },
    data() {
      return {
        markers: [],
        currentGroupId: null,
        inputText: '',
        searchText: '',
        toggleList: [],
        drawer: false,
        intervalId: '',
        intervalTime: 1800000, // 30分毎にセンサーデータを更新
        blinkStart: false,
        isComposing: false,
        targetMarkerId: '',
        filterStatus: [0, 1, 2, 3, 4, 5], // 0: E, 1: C, 2: M, 3: 接続断, 4: start, 5: 通信可能
        consumerMenu: false,
        progression: {
          value: 0,
          active: false,
        },
      };
    },
    computed: {
      ...mapGetters('auth', ['user_info']),
      ...mapGetters('groupAuthorities', ['get_all_devices']),
      // 各カードのカラーコードを返す
      cardColor() {
        return (value) => {
          if (value.disConnection) {
            // 通信断
            return '#9E9E9E';
          } else {
            if (value.emergency) {
              // E
              return '#EF5350';
            } else if (value.caution) {
              // C
              return '#FF9800';
            } else if (value.maintenance) {
              // M
              return '#FDD835';
            } else if (value.start) {
              // start
              return '#8BC34A';
            } else {
              // 通信可
              return '#212121';
            }
          }
        };
      },
      // modelMappingからデバイスの種類を返す
      deviceType() {
        return (value) => {
          return modelMapping[value].type;
        };
      },
      // 選択中のマーカーの情報を返す
      targetMarker() {
        return this.markers.find((marker) => marker.id === this.targetMarkerId);
      },
      // 画面に表示するマーカー情報を返す
      displayMarkers() {
        if (this.searchText) {
          return this.markers
            .filter((marker) => {
              return marker.title.includes(this.searchText);
            })
            .filter((marker) => this.filterStatus.includes(marker.status));
        } else {
          return this.markers.filter((marker) => this.filterStatus.includes(marker.status));
        }
      },
      // メンテナンス通知のアイコン情報を返す
      maintenanceNotificationIcon() {
        return (value) => {
          const icons = {
            danger: {
              name: 'clock_loader_90',
              color: '#FF0000',
            },
            warning: {
              name: 'clock_loader_60',
              color: '#FFA500',
            },
            notice: {
              name: 'clock_loader_10',
              color: '#00FF26',
            },
          };
          return icons[value] || { name: '', color: '' };
        };
      },
    },
    created() {
      this.$store.commit('loading/start_loading');
      const groupId = this.$route.params.device_group_id;
      if (groupId) {
        this.currentGroupId = groupId;
      }
    },
    async mounted() {
      try {
        await this.getMarkers();
        this.$store.commit('loading/end_loading');
        // 初回実行
        await this.setSensorData();
        // センサーデータを定期的に更新する設定
        this.setSensorDataInterval();
        // 点滅を同期させるために点滅を開始させる
        this.blinkStart = true;
      } catch (error) {
        console.error(error);
      } finally {
        this.progression.active = false;
        this.progression.value = 0;
        this.$store.commit('loading/end_loading');
      }
    },
    methods: {
      selectedGroupChange(group) {
        if (group.children.length > 0) {
          this.$router.push({
            name: 'HomeAdmin',
            params: {
              device_group_id: group.device_group_id,
            },
          });
        }
      },
      // マーカーの情報を取得する関数
      async getMarkers() {
        // メンテナンス通知の情報を取得
        const maintenanceNotifications = await this.getMaintenanceNotifications(this.user_info.userId);
        const markers = [];
        const codes = [];
        // allDevicesをdevice_group_idをキーとしたMapに変換
        const deviceMap = new Map();
        for (const device of this.get_all_devices) {
          if (!deviceMap.has(device.device_group_id)) {
            // device_group_idがdeviceMapに存在しない場合は空配列で初期化
            deviceMap.set(device.device_group_id, []);
          }
          // device_group_idをキーとして、値にデバイス情報を追加
          deviceMap.get(device.device_group_id).push(device);
        }

        // 現階層のdeviceGroup配下で葉となるdeviceGroupのリストを取得
        const leafGroups = this.$store.getters['groupAuthorities/get_leaf_group'](this.currentGroupId);

        for (const group of leafGroups) {
          // device_group_idをキーとしてdeviceMapからデバイス情報を取得、取得できない場合は空配列
          const devices = deviceMap.get(group.device_group_id) || [];
          for (const device of devices) {
            // デバイス情報からcodeを取得してcodes配列に追加
            codes.push(device.serial_no.replace(/^.*_/, ''));
          }
        }
        // codesの重複を削除
        const uniqueCodes = [...new Set(codes)];
        const sPassCustomers = await this.azureRequest(`/api/getSmartpassCustomers`, 'POST', {
          codes: uniqueCodes,
        });
        let i = 0;
        for (const sPassCustomer of sPassCustomers) {
          if (sPassCustomer.latitude && sPassCustomer.longitude) {
            // 緯度経度が存在する場合のみマーカーを追加
            const position = { lat: Number(sPassCustomer.latitude), lng: Number(sPassCustomer.longitude) };
            if (i === 0) {
              // 最初に取得できた座標を中心に表示
              this.$refs.googleMap.setCenter(position);
            }
            // serial_noの_以降の文字列がcode一致し、device_group_name_locale1がnameと一致するデバイスを取得
            const devices = this.get_all_devices.filter(
              (device) =>
                device.serial_no.replace(/^.*_/, '') === sPassCustomer.code &&
                device.device_group_name_locale1 === sPassCustomer.name
            );

            if (devices.length > 0) {
              // devicesから重複のないdevice_group_idを取得して、leafGroupsからdevice_group_idが一致するデータを取得
              const deviceGroups = leafGroups.filter((group) =>
                devices.map((device) => device.device_group_id).includes(group.device_group_id)
              );

              // devices配列からserial_noの重複を除去する
              const uniqueSerialNoDevices = devices.filter(
                (device, index, self) => index === self.findIndex((t) => t.serial_no === device.serial_no)
              );

              for (const uniqueSerialNoDevice of uniqueSerialNoDevices) {
                // deviceのメンテナンス通知のステータスを設定
                this.setMaintenanceNotificationStatus(uniqueSerialNoDevice, maintenanceNotifications);
              }

              // devicesが存在する場合のみマーカー情報を追加
              markers.push({
                id: sPassCustomer.code,
                status: 3,
                deviceGroups: deviceGroups,
                position: position,
                title: sPassCustomer.name,
                background: '#9E9E9E',
                borderColor: '#FFFFFF',
                scale: 1,
                glyphColor: '#000000',
                glyph: uniqueSerialNoDevices.length.toString(),
                devices: uniqueSerialNoDevices,
                start: 0,
                emergency: 0,
                caution: 0,
                maintenance: 0,
                disConnection: 0,
                communication: 0,
              });
            }
            i++;
          }
        }
        this.markers = markers;
        this.$refs.googleMap.updateMarkers(this.displayMarkers);
      },
      // 最新のセンサーデータを全件取得する関数
      async getLatestSensorDatas(markers) {
        const sensor_list = [];
        for (const marker of markers) {
          for (const device of marker.devices) {
            sensor_list.push({
              model_id: device.model_id,
              serial_no: device.serial_no,
            });
          }
        }
        return await this.apiRequest(
          '/v1/sensor-data-file-mgt/getLatestSensorData',
          'POST',
          {
            sensor_list: sensor_list,
          },
          false
        );
      },
      // 配列を groupSize 件ずつに分割する関数
      chunkArray(array, groupSize) {
        // 分割結果を入れる配列
        const result = [];
        // 必要なグループ数だけループ
        const groupCount = Math.ceil(array.length / groupSize);
        for (let i = 0; i < groupCount; i++) {
          // 開始インデックスを計算
          const start = i * groupSize;
          // 終了インデックスを計算
          const end = start + groupSize;
          // 指定範囲の配列を取り出して追加
          const chunk = array.slice(start, end);
          result.push(chunk);
        }
        return result;
      },
      // センサーデータを取得して設定する関数
      async setSensorData() {
        // markers配列を50件ずつに分割して配列に格納
        const groupedMarkers = this.chunkArray(this.markers, 50);
        // マーカーの数をカウントする変数
        let markerCount = 0;
        // 進捗バーの表示
        this.progression.active = true;
        // 全てdeviceの最新センサーデータを取得
        for (const groupMarker of groupedMarkers) {
          // 50件毎のマーカーの最新センサーデータを取得
          const groupLatestSensorDatas = await this.getLatestSensorDatas(groupMarker);
          for (const marker of groupMarker) {
            // マーカーのステータスを初期化
            marker.start = 0;
            marker.emergency = 0;
            marker.caution = 0;
            marker.maintenance = 0;
            marker.communication = 0;
            marker.disConnection = 0;
            marker.glyphColor = '#000000';

            for (const device of marker.devices) {
              const { model_id: modelId, serial_no: serialNo } = device;

              const latestSensorDatas = groupLatestSensorDatas.find((item) => {
                return item.modelId === modelId && item.serialNo === serialNo;
              });
              if (latestSensorDatas) {
                // LED ランプ状態(Hex)のオブジェクトのみ抽出
                const panelLamp = latestSensorDatas.timeList.find((item) => item.sensorId === 'sn_D027');
                // panelLampが存在し、データが存在する場合
                if (panelLamp && panelLamp.dataList.length > 0) {
                  // 取得したmeasureTimeをutcのdayjsオブジェクトに変換
                  const parsedDate = this.$dayjs.utc(
                    panelLamp.dataList[0].measureTime.substring(0, 14),
                    'YYYYMMDDHHmmss'
                  );
                  // 現在時刻をutcのdayjsオブジェクトに変換
                  const nowUtc = this.$dayjs.utc();
                  // 現在時刻と取得したmeasureTimeの差分を分単位で取得
                  const diffMinutes = nowUtc.diff(parsedDate, 'minute');

                  // 10進数を2進数に変換し、ビット情報の配列に変換
                  const lampDatas = Number(panelLamp.dataList[0].data).toString(2).match(/.{1}/g).reverse();

                  // センサーデータが取得できていれば通信可能とする
                  device.communication = true;
                  device.start = Boolean(lampDatas[modelMapping[modelId].start] === '1');
                  device.emergency = Boolean(lampDatas[modelMapping[modelId].emergency] === '1');
                  device.caution = Boolean(lampDatas[modelMapping[modelId].caution] === '1');
                  device.maintenance = Boolean(lampDatas[modelMapping[modelId].maintenance] === '1');
                  // 160分以上経過していれば接続断とする
                  device.disConnection = Boolean(diffMinutes >= 160);
                } else {
                  // LED ランプ状態(Hex)のオブジェクトが存在しない場合は通信不可とする
                  device.communication = false;
                  device.start = false;
                  device.emergency = false;
                  device.caution = false;
                  device.maintenance = false;
                  device.disConnection = true;
                }
              } else {
                // センサーデータが取得できない場合は通信不可とする
                device.communication = false;
                device.start = false;
                device.emergency = false;
                device.caution = false;
                device.maintenance = false;
                device.disConnection = true;
              }
              // マーカーのステータス判定のためにdeviceのステータスを判定してカウント
              if (device.disConnection) {
                // 接続断
                marker.disConnection++;
              } else {
                if (device.emergency) {
                  // E
                  marker.emergency++;
                } else if (device.caution) {
                  // C
                  marker.caution++;
                } else if (device.maintenance) {
                  // M
                  marker.maintenance++;
                } else if (device.start) {
                  // start
                  marker.start++;
                } else {
                  // 疎通可能
                  marker.communication++;
                }
              }
            }
            // マーカーの状態を更新
            if (marker.devices.length !== marker.disConnection) {
              // 全てのdeviceが接続断ではない場合
              if (marker.emergency > 0) {
                marker.status = 0;
                marker.background = '#EF5350';
              } else if (marker.caution > 0) {
                marker.status = 1;
                marker.background = '#FF9800';
              } else if (marker.maintenance > 0) {
                marker.status = 2;
                marker.background = '#FDD835';
              } else if (marker.start > 0) {
                marker.status = 4;
                marker.background = '#8BC34A';
              } else {
                marker.status = 5;
                marker.background = '#212121';
                marker.glyphColor = '#FFFFFF';
              }
            } else {
              // device全てが接続断の場合
              marker.status = 3;
              marker.background = '#9E9E9E';
            }
            // マーカーの情報を更新
            this.$refs.googleMap.updateMarker(marker);
            markerCount++;
            // 進捗バーの更新
            this.progression.value = Math.floor((markerCount / this.markers.length) * 100);
          }
        }
        this.progression.active = false;
        this.progression.value = 0;
      },
      // センサーデータを一定間隔毎に更新する関数
      setSensorDataInterval() {
        this.intervalId = setInterval(async () => {
          await this.setSensorData();
        }, this.intervalTime);
      },
      async getMaintenanceNotifications(userId) {
        const maintenanceNotifications = await this.azureRequest(
          '/api/getMaintenanceNotifications',
          'GET',
          {
            userId: userId,
          },
          false
        );
        return maintenanceNotifications;
      },
      setMaintenanceNotificationStatus(device, maintenanceNotifications) {
        device.maintenanceNotificationStatus = null;
        if (maintenanceNotifications) {
          const maintenanceNotification = maintenanceNotifications.find(
            (item) => item.equipmentNo === device.device_name_locale2
          );
          if (maintenanceNotification) {
            device.maintenanceNotificationStatus = maintenanceNotification.status;
          }
        }
      },
      closeDrawer() {
        this.drawer = false;
        // マーカーのbounceを解除
        this.$refs.googleMap.removeBounceMarker();
      },
      // マーカーを選択した際にサイドバーを表示する関数
      setTargetMarker(markerId) {
        this.targetMarkerId = markerId;
        this.drawer = true;
      },
      // マーカーを検索する関数
      searchMarker(key) {
        // 入力中の場合のEnterキーは検索しない
        if (this.isComposing && key === 'enter') return;
        this.searchText = this.inputText;
        this.$refs.googleMap.updateMarkers(this.displayMarkers);
      },
      // マーカー検索のクリア
      searchClear() {
        this.inputText = '';
        this.searchMarker();
      },
      // マーカーの状態に応じてフィルタリングする関数
      setFilterStatus(type) {
        if (type === 'all') {
          this.toggleList = [];
          this.filterStatus = [0, 1, 2, 3, 4, 5];
        } else {
          this.filterStatus = this.toggleList;
        }
        this.$refs.googleMap.updateMarkers(this.displayMarkers);
      },
      // 需要家ページに遷移する関数
      openHomeConsumerPage(deviceGroupId) {
        const routeData = this.$router.resolve({
          name: 'HomeConsumer',
          params: {
            device_group_id: deviceGroupId,
          },
        });
        window.open(routeData.href, '_blank');
      },
    },
    beforeDestroy() {
      clearInterval(this.intervalId);
    },
  };
</script>
<style scoped>
  .gmap-control-shadow {
    box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
  }
  .right-nav-header {
    position: sticky;
    top: 0;
    z-index: 2;
  }
  .sensor-summary {
    border: thin solid #0000001f;
  }
  .sensor-data-title {
    border-right: thin solid #0000001f;
    box-sizing: border-box;
    width: 50%;
  }
  .sensor-data-number {
    width: 50%;
  }
  .control-area {
    width: 100%;
    position: absolute;
    z-index: 4;
    top: 12px;
  }
  .serach-marker-input {
    max-width: 50%;
  }
  .btn-toggle .v-btn--active {
    color: white;
    background-color: #162a4f;
  }
  .btn-toggle .v-btn--active::before {
    opacity: 0;
  }
</style>
